import {} from '../../transports';
import { UserActionSeverity, userActionStartByApiCallEventName } from './const';
export var UserActionState;
(function (UserActionState) {
    UserActionState[UserActionState["Started"] = 0] = "Started";
    UserActionState[UserActionState["Halted"] = 1] = "Halted";
    UserActionState[UserActionState["Cancelled"] = 2] = "Cancelled";
    UserActionState[UserActionState["Ended"] = 3] = "Ended";
})(UserActionState || (UserActionState = {}));
//# sourceMappingURL=types.js.map